import { SPECIALIZATIONS } from '@klaro7/shared-types';

interface SpecializationsInputProps {
  value: string[];
  onChange: (specializations: string[]) => void;
}

export function SpecializationsInput({ value, onChange }: SpecializationsInputProps) {
  const toggleSpecialization = (spec: string) => {
    if (value.includes(spec)) {
      onChange(value.filter((s) => s !== spec));
    } else {
      onChange([...value, spec]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {SPECIALIZATIONS.map((spec) => {
        const isSelected = value.includes(spec);
        return (
          <button
            key={spec}
            type="button"
            onClick={() => toggleSpecialization(spec)}
            className={`rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
              isSelected
                ? 'bg-brand-teal text-white'
                : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200'
            }`}
          >
            {spec}
          </button>
        );
      })}
    </div>
  );
}
